import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import image from '../images/home-1.jpg';
import imageTop from '../images/home-2.jpg';
import imageBottom from '../images/home-3.jpg';

export default class extends PureComponent {
    componentDidMount() {
        this.animatePage();
        this.props.setWhiteLogo(false);
    }

    animatePage() {
        const home = document.getElementById('Home');
        setTimeout(() => {
            home.classList.add('__active');
        }, 100);
    }

    render() {
        const { changePage } = this.props;

        return (
            <div className="home" id="Home">
                <div className="row no-gutters h-100">
                    <div className="col-lg-6 ">
                        <div className="home-main" style={{ backgroundImage: `url('${image}')` }}>
                            <h1 className="home-title">
                                How<br />good is<br />
                                <span>
                                    m<span>y</span>
                                </span>{' '}
                                job?
                            </h1>
                        </div>
                    </div>
                    <div className="col-lg-6  d-none d-lg-block">
                        <div
                            className="home-top"
                            style={{ backgroundImage: `url('${imageTop}')` }}
                        />
                        <div
                            className="home-bottom"
                            style={{ backgroundImage: `url('${imageBottom}')` }}
                        />
                    </div>
                </div>
                <div className="home-button">
                    <Link  to="/about" className="beginbutton">
                        <div className="beginbutton-inner">
                            Begin quiz
                            <span />
                        </div>
                    </Link>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Home/index.js